import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import { RefObject, forwardRef, useEffect, useState } from 'react'

import * as S from './styled'

type Props = {
  body: any
  forwardRef: RefObject<HTMLDivElement> | null
}
const LightGalery: React.FC<Props> = ({ forwardRef, body }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const [currentIndex, setCurrentIndex] = useState(0)
  const [imageAlt, setImageAlt] = useState<string[]>([])
  const [images, setImages] = useState<string[]>([])

  useEffect(() => {
    if (forwardRef?.current) {
      const imageNodes = forwardRef?.current.querySelectorAll('img')
      const imageList: string[] = []
      const imageAltList: string[] = []
      for (let index = 0; index < imageNodes.length; index++) {
        const image = imageNodes[index]
        console.log('aqui 1')

        if (
          !image.getAttribute('src') ||
          image.getAttribute('src')?.includes('base64')
        )
          continue

        console.log('aqui 2')
        image.addEventListener('click', () => {
          setCurrentIndex(index)
          onOpen()
        })

        console.log('aqui 3')
        imageAltList.push(
          image.getAttribute('alt')?.replace('foto da grama ', '') || ''
        )
        imageList.push(image.getAttribute('src') || '')
      }

      setImages(imageList)
      setImageAlt(imageAltList)
    }
  }, [forwardRef, body])

  return (
    <Modal onClose={onClose} isOpen={isOpen} isCentered size="xl">
      <ModalOverlay bg="rgba(0, 0, 0, 0.75)" />
      <ModalContent>
        <S.CloseModalWrapper>
          <ModalCloseButton />
        </S.CloseModalWrapper>
        <S.Content>
          <ModalBody>
            <S.WrapImage>
              <img
                src={images[currentIndex] || ''}
                title={images[currentIndex]}
                alt={images[currentIndex]}
              />
            </S.WrapImage>
            {/* <Text>{imageAlt[currentIndex]}</Text> */}
            {/* <S.WrapButtons>
            <Button
              onClick={() =>
                setCurrentIndex((value) => {
                  const newValue = value - 1
                  if (newValue < 0) {
                    return images.length - 1
                  }

                  return newValue
                })
              }
            >
              Anterior
            </Button>
            <Button
              colorScheme="blue"
              onClick={() =>
                setCurrentIndex((value) => {
                  const newValue = value + 1
                  if (newValue > images.length - 1) {
                    return 0
                  }

                  return newValue
                })
              }
            >
              Próximo
            </Button>
          </S.WrapButtons> */}
          </ModalBody>
        </S.Content>
      </ModalContent>
    </Modal>
  )
}

// eslint-disable-next-line react/display-name
const LightGaleryRef = forwardRef((props: any, ref: any) => (
  <LightGalery {...props} forwardRef={ref} />
))

export default LightGaleryRef
